import { Component } from '@theme/component';

/**
 * @typedef {object} UniformsTierPricingRefs
 * @property {HTMLButtonElement} [toggle]
 * @property {HTMLElement} [table]
 */

/**
 * @extends {Component<UniformsTierPricingRefs>}
 */
class UniformsTierPricing extends Component {
  toggle() {
    const { toggle, table } = this.refs;
    if (!toggle || !table) return;

    const isOpen = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(isOpen));
    table.hidden = !isOpen;
  }
}

if (!customElements.get('uniforms-tier-pricing')) {
  customElements.define('uniforms-tier-pricing', UniformsTierPricing);
}
